<template>
  <div class="mobile">
    <div class="design-header">
      <h2 class="title">オリジナルスタイル</h2>
    </div>
    <div class="text-box">
      <ul class="editor-design">
        <li class="title">スタイル</li>
        <li class="code-mirror-wrapper">
          <code-mirror-editor
            :mode="'css'"
            :code="originalStyle"
            :placeholder="'※ <style></style> は記述せず、\r\nルールセットのみを記載してください\r\n入力例:\r\n p { color: #FFFFFF; }'"
            @change="changeOriginalStyle($event)"
          />
        </li>
        <li>
          <button class="w-b-btn apply" @click="applyOriginalStyle()">適用</button>
        </li>
        <li class="title">メディアクエリ</li>
        <li class="code-mirror-wrapper">
          <code-mirror-editor
            :mode="'css'"
            :code="originalHeadStyle"
            :placeholder="'※ <style></style> は記述せず、\r\nルールセットのみを記載してください\r\n入力例:\r\n @media screen and (max-width: 480px) { p { color: #000000 !important; } }\n表示確認はプレビューを使用してください'"
            @change="changeOriginalHeadStyle($event)"
          />
        </li>
      </ul>
    </div>
    <div class="design-footer">
      <button
        class="close normal-btn"
        @click="closeButton"
        data-shortcut-esc="editorCloseButton"
      >
        閉じる
      </button>
    </div>
  </div>
</template>

<script>
import Base from '@/components/Content/Palette/ContentDesign/ContentDesignBase'
import CodeMirrorEditor from '@/components/Content/Palette/EditPartDesign/Editor/Code/CodeMirrorEditor'
import jsBeautify from 'js-beautify'
import ShortCutBase from '@/mixins/ShortCutBase'

export default {
  mixins: [
    Base,
    ShortCutBase
  ],
  components: {
    CodeMirrorEditor,
  },
  data () {
    return {
      originalStyle: '',
      originalHeadStyle: '',
    }
  },
  created () {
    this.originalStyle = jsBeautify.css(this.$store.state.originalStyle, { indent_size: 2, space_in_empty_paren: true })
    this.originalHeadStyle = jsBeautify.css(this.$store.state.originalHeadStyle, { indent_size: 2, space_in_empty_paren: true })
  },
  methods: {
    applyOriginalStyle () {
      this.$store.commit('applyOriginalStyle', {
        originalStyle: this.originalStyle,
      })
    },
    changeOriginalStyle (value) {
      this.$store.commit('updateOriginalStyle', {
        value: value,
      })
      this.originalStyle = value
    },
    changeOriginalHeadStyle (value) {
      this.$store.commit('updateOriginalHeadStyle', {
        value: value,
      })
      this.originalHeadStyle = value
    },
  },
}
</script>

<style lang="scss" scoped>
.design-header, .design-footer {
  width: 100%;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #dbdbdb;
  background: #ffffff;
  position: relative;
}
.design-header {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  border-top: 1px solid #dbdbdb;
  background: #f8f8f8;
  .title {
    color: $commonFontColor;
  }
}
.design-footer {
  vertical-align: bottom;
  border-top: #dbdbdb 1px solid;
  text-align: right;
  .close {
    width: auto;
    display: block;
    font-size: 14px;
    border-radius: 5px;
    color: #fff;
    border: solid 1px #484848;
    background: #484848;
    opacity: 1;
    position: absolute;
    top: 6px;
    right: 8px;
    &:hover {
      background: #484848;
      opacity: 0.8;
    }
  }
}
.text-box {
  height: calc(100vh -  240px);
  overflow: auto;
  .apply {
    display: block;
    margin: 6px 8px 6px auto;
  }
}
.editor-design {
  > li {
    margin: 0;
    width: 100%;
    &.title {
      box-sizing: border-box;
    }
    &.code-mirror-wrapper {
      padding-top: 10px;
    }
  }
}
</style>
